type holyDayParms = {
  pickup_delay_day: number;
  delivery_delay_day: number;
  time_slot: string[];
  pickup_time_slot: string[];
  delivery_time_slot: string[];
  holi_day: any;
};

const holiDayData: {
  [key: string]: holyDayParms;
} = require('assets/data/json/offline_holiday.json');

let holiDayNetData: {
  [key: string]: holyDayParms;
};

(async () => {
  try {
    const response = await fetch(
      'https://mintwk.edge.naverncp.com/mint-house/offline_holiday.json',
      {
        cache: 'no-cache',
        mode: 'cors',
        // credentials: 'include',
        // headers: {
        //   'access-control-allow-origin': '*',
        //   'Content-type': 'application/json; charset=UTF-8',
        // },
      },
    );

    holiDayNetData = await response.json();
  } catch (error) {
    console.error('🆘 holiDay', error);
  }
})();

export const getHoliDay = (): any => {
  if (!holiDayNetData || !holiDayNetData['holi_day']) {
    if (!holiDayData || !holiDayData['holi_day']) {
      return [];
    }
    return holiDayData['holi_day'];
  }
  return holiDayNetData['holi_day'];
};

export const getPickupTimeSlot = (): any => {
  if (!holiDayNetData || !holiDayNetData['pickup_time_slot']) {
    if (!holiDayData || !holiDayData['pickup_time_slot']) {
      return [];
    }
    return holiDayData['pickup_time_slot'];
  }
  return holiDayNetData['pickup_time_slot'];
};

export const getDeliveryTimeSlot = (): any => {
  if (!holiDayNetData || !holiDayNetData['delivery_time_slot']) {
    if (!holiDayData || !holiDayData['delivery_time_slot']) {
      return [];
    }
    return holiDayData['delivery_time_slot'];
  }
  return holiDayNetData['delivery_time_slot'];
};

export const getPickupDelay = (): any => {
  if (!holiDayNetData || !holiDayNetData['pickup_delay_day']) {
    if (!holiDayData || !holiDayData['pickup_delay_day']) {
      return [];
    }
    return holiDayData['pickup_delay_day'];
  }
  return holiDayNetData['pickup_delay_day'];
};

export const getDeliveryDelay = (): any => {
  if (!holiDayNetData || !holiDayNetData['delivery_delay_day']) {
    if (!holiDayData || !holiDayData['delivery_delay_day']) {
      return [];
    }
    return holiDayData['delivery_delay_day'];
  }
  return holiDayNetData['delivery_delay_day'];
};

export const getTimeSlotTextByTime = (time: string) => {
  return `${time}:00 ~${Number.parseInt(time) + 2}:00`;
};
